<template>
    <b-row>
        <b-col sm="6" lg="6" xl="3">
            <v-statistic-card-small class="statistic-card statistic-card-small mb-3"
                                    data-type="countSchools"
                                    subheader="Количество школ, реализующих проект"
                                    variant="info"
                                    v-if="loadedCountOfOrganizations"
            >
              <b-btn
                variant="outline-info"
                v-on:click="onSchoolsStatsEdit"
              >
                <p class="subheader mb-0"><em class="fas fa-edit"></em> Редактировать </p>
              </b-btn>
                <v-statistic-card-small-chart v-if="loadedCountOfOrganizations"
                                              class="chart-wrapper"
                                              :labels="labelsForCount"
                                              data-type="countSchools"
                                              :key="rerender"
                />
            </v-statistic-card-small>
        </b-col>

        <b-col sm="6" lg="6" xl="3">
            <v-statistic-card-small class="statistic-card statistic-card-small mb-3"
                                    data-type="countDO"
                                    subheader="Количество дочерних обществ, реализующих проект"
                                    variant="warning"
                                    v-if="loadedCountOfOrganizations"
            >
              <b-btn
                variant="outline-warning"
                v-on:click="onDOStatsEdit"
              >
                <p class="subheader mb-0"><em class="fas fa-edit"></em> Редактировать </p>
              </b-btn>
                <v-statistic-card-small-chart v-if="loadedCountOfOrganizations"
                                              class="chart-wrapper"
                                              :labels="labelsForCount"
                                              data-type="countDO"
                                              :key="rerender"
                />
            </v-statistic-card-small>
        </b-col>

        <b-col sm="6" lg="6" xl="3">
            <v-statistic-card-small class="statistic-card statistic-card-small mb-3"
                                    data-type="countClasses"
                                    subheader="Количество классов, реализующих проект"
                                    variant="success"
                                    v-if="loadedCountOfOrganizations"
            >
              <b-btn
                variant="outline-success"
                v-on:click="onClassesStatsEdit"
              >
                <p class="subheader mb-0"><em class="fas fa-edit"></em> Редактировать </p>
              </b-btn>
                <v-statistic-card-small-chart v-if="loadedCountOfOrganizations"
                                              class="chart-wrapper"
                                              :labels="labelsForCount"
                                              data-type="countClasses"
                                              :key="rerender"
                />
            </v-statistic-card-small>
        </b-col>

        <b-col sm="6" lg="6" xl="3">
            <v-statistic-card-small class="statistic-card statistic-card-small mb-3"
                                    data-type="studentsToPartners"
                                    subheader="Стали целевыми студентами"
                                    variant="primary"
                                    :year="2015"
                                    v-if="loadedStudentsToPartners"
            >
              <b-btn
                variant="outline-primary"
                v-b-modal.studentsToPartnersModal
              >
                <p class="subheader mb-0"><em class="fas fa-edit"></em> Редактировать </p>
              </b-btn>
              <v-statistic-card-small-chart v-if="loadedStudentsToPartners"
                                            class="chart-wrapper"
                                            data-type="studentsToPartners"
                                            :labels="labelsForPartners"
                                            :key="rerender"
              />
            </v-statistic-card-small>
        </b-col>
      <b-modal id="orgStatsEdit"
               centered
      >
        <template #modal-title>
          <h5 v-if="editType === 1">
            <em class="fas fa-edit"></em> Редактирование классов, реализующих проект</h5>
          <h5 v-else-if="editType === 2">
            <em class="fas fa-edit"></em> Редактирование школ, реализующих проект</h5>
          <h5 v-else><em class="fas fa-edit">
            </em> Редактирование дочерних организаций, реализующих проект</h5>
        </template>
        <template #default>
          <div class="count-of-orgs-grid">
            <ag-grid-vue
              class="count-of-orgs-grid-ag ag-theme-material"
              :gridOptions="gridOptions"
              :columnDefs="columnDefs"
              @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </div>
        </template>
        <template #modal-footer>
          <b-button cols="auto" @click="onSubmit"  variant="primary">
            <em class="fas fa-save"></em> Сохранить
          </b-button>
        </template>
      </b-modal>
      <students-to-partners-modal></students-to-partners-modal>
    </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import VStatisticCardSmall from '@/components/statistic/CardSmall.vue'
import VStatisticCardSmallChart from '@/components/statistic/CardSmallChart.vue'
import StudentsToPartnersModal from '@/components/statistic/modals/StudentsToPartnersModal.vue'
import NumericEditor from '@/components/statistic/editors/NumericEditor'

export default {
  name: 'Main',
  data() {
    return {
      loadedStudentsToPartners: false,
      loadedCountOfOrganizations: false,
      rerender: false,
      gridOptions: {
        defaultColDef: {
          headerClass: 'ag-grid-table-header',
          sortable: true,
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        domLayout: 'autoHeight',
        pagination: true,
        paginationPageSize: 5,
        headerHeight: 40,
        localeText: AG_GRID_LOCALE_RU,
        frameworkComponents: {
          NumericEditor
        }
      },
      columnDefs: [],
      rowData: null,
      editType: 0
    }
  },
  components: {
    VStatisticCardSmallChart,
    VStatisticCardSmall,
    StudentsToPartnersModal,
    'ag-grid-vue': AgGridVue
  },
  props: {
    loaded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelsForPartners() {
      const year = Math.max
        .apply(null, (this.studentsToPartnersForYear
          .filter((st) => st.count !== 0))
          .map((st) => st.year))
      return Array.from({ length: 6 }, (v, k) => k + year - 5)
    },
    labelsForCount() {
      const year = Math.max.apply(null, this.countSchoolsDOClasses.map((st) => st.year))
      return Array.from({ length: 6 }, (v, k) => k + year - 5)
    },
    ...mapGetters({
      orgs: 'dicts/getOrganizations',
      studentsToPartnersForYear: 'statistics/getStatsStudentsToPartners',
      countSchoolsDOClasses: 'statistics/getStatsCountSchoolsDOClasses'
    })
  },
  created() {
    this.fetchStatsCountSchoolsDOClasses()
      .then(() => {
        this.rowData = this.countSchoolsDOClasses
        this.loadedCountOfOrganizations = true
      }).catch((error) => {
        console.log(error)
      })
  },
  mounted() {
    this.fetchStatsStudentsToPartners().then(() => {
      this.loadedStudentsToPartners = true
    })
  },
  methods: {
    yearFormatter(params) {
      const year = Number(params.value)
      return `${year - 1}-${year}`
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.setRowData(this.rowData)
    },
    onSchoolsStatsEdit() {
      this.columnDefs = [
        {
          headerName: 'Год',
          field: 'year',
          sort: 'desc',
          valueFormatter: this.yearFormatter
        },
        {
          headerName: 'Школы',
          field: 'countSchools',
          editable: true,
          cellEditor: 'NumericEditor'
        }
      ]
      this.editType = 2
      this.modalTitle = 'Школы, реализующие проект'
      this.$bvModal.show('orgStatsEdit')
    },
    onDOStatsEdit() {
      this.columnDefs = [
        {
          headerName: 'Год',
          field: 'year',
          sort: 'desc',
          valueFormatter: this.yearFormatter
        },
        {
          headerName: 'Организации',
          field: 'countDO',
          editable: true,
          cellEditor: 'NumericEditor'
        }
      ]
      this.editType = 0
      this.modalTitle = 'Дочерняя организация, реализующие проект'
      this.$bvModal.show('orgStatsEdit')
    },
    onClassesStatsEdit() {
      this.columnDefs = [
        {
          headerName: 'Год',
          field: 'year',
          sort: 'desc',
          valueFormatter: this.yearFormatter
        },
        {
          headerName: 'Классы',
          field: 'countClasses',
          editable: true,
          cellEditor: 'NumericEditor'
        }
      ]
      this.editType = 1
      this.modalTitle = 'Классы, реализующие проект'
      this.$bvModal.show('orgStatsEdit')
    },
    repeatRender() {
      this.rerender = !this.rerender
    },
    async onSubmit() {
      try {
        await this.updateStatsCountSchoolsDOClasses(this.rowData)
        await this.fetchStatsStudentsToPartners()
        await this.fetchStatsCountSchoolsDOClasses()
        this.rowData = this.countSchoolsDOClasses
        this.rerender = !this.rerender
        this.pushToasts({
          title: 'Уведомление',
          message: 'Обновление данных произошло успешно'
        })
      } catch (error) {
        this.pushToasts({
          title: 'Ошибка',
          error: true,
          message: 'При обновлении данных произошла ошибка'
        })
        console.log(error)
      }
      this.$bvModal.hide('orgStatsEdit')
    },
    ...mapActions({
      fetchStatsStudentsToPartners: 'statistics/fetchStatsStudentsToPartners',
      fetchStatsCountSchoolsDOClasses: 'statistics/fetchStatsCountSchoolsDOClasses',
      updateStatsCountSchoolsDOClasses: 'statistics/updateStatsCountSchoolsDOClasses',
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style>
.count-of-orgs-grid .count-of-orgs-grid-ag {
  width: 100%;
  height: 100%;
}

.count-of-orgs-grid .ag-grid-table-header {
  font-size: 15px;
  display: flex;
  color: #000;
  font-weight: bold;
}

.count-of-orgs-grid .ag-theme-material .ag-cell.ag-cell-inline-editing {
  padding: 24px;
  height: 48px !important;
  border: 0 !important;
  box-shadow: none !important;
  background: none !important;
}

.count-of-orgs-grid {
  width: 100%;
  height: 45vh;
}

.chart-wrapper {
  height: 70px;
}
</style>
